'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import RateCardDisplay from './components/RateCardDisplay';
import ToastProvider from '@/components/ui/Toast';
import { CreditCard } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export default function RateCardPage() {
  const { t } = useLanguage();

  return (
    <AppLayout>
      <ToastProvider />
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 xl:px-12 2xl:px-16 py-10">
        {/* Page Header */}
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-accent/30 bg-accent/10 text-accent text-xs font-bold uppercase tracking-widest mb-4">
            <CreditCard size={12} />
            {t?.rateCard?.badge}
          </div>
          <h1 className="text-4xl xl:text-5xl font-extrabold text-foreground leading-tight">
            {t?.rateCard?.headline1}{' '}
            <span className="text-gradient-amber">{t?.rateCard?.headline2}</span>
          </h1>
          <p className="text-muted-foreground text-base xl:text-lg mt-3 max-w-xl mx-auto">
            {t?.rateCard?.subtitle}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <RateCardDisplay />
        </div>
      </div>
    </AppLayout>
  );
}